import React from 'react';
import styles from './TextEffectsStriped.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import clsx from 'clsx';

export type TextEffectsStripedProps = TextEffectsSharedProps;

const TextEffectsStriped: React.FC<TextEffectsSharedProps> = props => {
  const { text, reducedMotion } = props;

  return (
    <TextEffectsShared {...props}>
      <div
        className={clsx(styles.container, {
          [styles.reducedMotion]: reducedMotion,
        })}
        data-testid={TestIds.viewer.container}
      >
        <div data-testid={TestIds.viewer.text}>{text}</div>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsStriped;
